import { omit } from 'lodash';
import { ActivityAudioAction, UseActivityAudioState } from './types';

export const getDefaultAppSoundState = (): UseActivityAudioState => ({
  captions: {
    currentCaption: '',
  },
  currentSound: null,
  genericSoundMap: null,
  genericSoundsLoaded: false,
  isLoading: false,
  isPlaying: false,
  previousSound: null,
  settings: {
    volume: 1,
    mute: false,
  },
  sounds: {},
});

export const soundReducer = (
  state: UseActivityAudioState,
  activityAudioAction: ActivityAudioAction
): UseActivityAudioState => {
  switch (activityAudioAction.type) {
    case 'PLAY_SOUND':
      return {
        ...state,
        isPlaying: activityAudioAction.payload.isPlaying,
        currentSound: activityAudioAction.payload.sound,
      };

    case 'REMOVE_SOUND':
      return {
        ...state,
        sounds: { ...omit(state.sounds, activityAudioAction.payload.name) },
      };

    case 'SET_CAPTION':
      return {
        ...state,
        captions: {
          ...state.captions,
          currentCaption: activityAudioAction.payload.caption,
        },
      };

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: activityAudioAction.payload.loading,
      };

    case 'SET_MUTE':
      return {
        ...state,
        settings: {
          ...state.settings,
          mute: activityAudioAction.payload.mute,
        },
      };

    case 'SET_SOUND':
      return {
        ...state,
        sounds: {
          ...state.sounds,
          [activityAudioAction.payload.name]: {
            sound: activityAudioAction.payload.sound,
            captions: activityAudioAction.payload.captions,
          },
        },
      };

    case 'SET_SOUNDS': {
      const newSoundsState = { ...state.sounds };
      activityAudioAction.payload.sounds.forEach((loadedSound) => {
        newSoundsState[loadedSound.name] = {};
        newSoundsState[loadedSound.name].sound = loadedSound.sound;
        newSoundsState[loadedSound.name].captions = loadedSound.captions;
      });
      return {
        ...state,
        sounds: newSoundsState,
      };
    }

    case 'SET_VOLUME':
      return {
        ...state,
        settings: {
          ...state.settings,
          volume: activityAudioAction.payload.volume,
        },
      };

    case 'STOP_SOUND': {
      return {
        ...state,
        currentSound: null,
        previousSound: state.currentSound,
        isPlaying: false,
      };
    }

    default:
      return state;
  }
};
